import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export interface MobileItemProps {
    icon: React.ReactNode;
    label: string;
    active: boolean;
    onClick?: () => void;
    /** Renders the tab as a real link (crawlable href) instead of a click target. */
    to?: string;
}

const MobileItem: React.FC<MobileItemProps> = ({ icon, label, active, onClick, to }) =>
    to ? (
        // The icon is a plain span here, so there's no button inside the link.
        <Box
            component={RouterLink}
            to={to}
            textAlign="center"
            aria-current={active ? "page" : undefined}
            sx={{ color: active ? "primary.main" : "text.secondary", textDecoration: "none" }}
        >
            <Box
                component="span"
                aria-hidden="true"
                sx={{ display: "inline-flex", padding: "4px", color: active ? "primary.main" : "text.secondary" }}
            >
                {icon}
            </Box>
            <Typography fontSize={12} color={active ? "primary.main" : "text.secondary"}>
                {label}
            </Typography>
        </Box>
    ) : (
        <Box
            textAlign="center"
            color={active ? "primary.main" : "text.secondary"}
            onClick={onClick}
            sx={{ cursor: "pointer" }}
        >
            <IconButton
                sx={{
                    color: active ? "primary.main" : "text.secondary",
                    padding: "4px",
                }}
            >
                {icon}
            </IconButton>
            <Typography fontSize={12} color={active ? "primary.main" : "text.secondary"}>
                {label}
            </Typography>
        </Box>
    );

export default MobileItem;
